import { Component, computed, DestroyRef, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationSkipped, Router } from '@angular/router';
import { filter } from 'rxjs';

import { ProductSelect } from '../../model/product-select';
import { TagItem } from '../../model/tag-item';
import { TagItemComponent } from './tag-item.component';

/** The `product-select` partial: the colour and size choosers on a product page. */
@Component({
  selector: 'product-select',
  imports: [TagItemComponent],
  host: {
    style: 'display: contents'
  },
  template: `
    <div class="flex-m flex-w p-b-10 choose-block">
      <div class="s-text15 w-size15 t-center choose-name">
        {{select().label}}
      </div>

      <div class="of-hidden w-size16">
        <div class="wrap-tags flex-w choose-value">
          @for (item of items(); track $index) {
            <tag-item [item]="item" [keepScroll]="true" (chosen)="choice.set($event)" />
          }
        </div>
      </div>
    </div>
    `
})
export class ProductSelectComponent {

  readonly select = input.required<ProductSelect>();

  readonly choice = signal<string | null>(null);

  readonly items = computed(() => {
    const choice = this.choice();
    return choice ? this.select().items.map(item => this.marked(item, choice)) : this.select().items;
  });

  constructor() {
    const navigations = inject(Router).events.pipe(
      filter(event => event instanceof NavigationEnd || event instanceof NavigationSkipped
        || event instanceof NavigationCancel || event instanceof NavigationError),
      takeUntilDestroyed(inject(DestroyRef)));
    navigations.subscribe(() => this.choice.set(null));
  }

  private marked(item: TagItem, choice: string): TagItem {
    return item.uri === choice
      ? { ...item, active: true, uri: undefined }
      : { ...item, active: false };
  }

}
